<div class="container">
    <div class="popin_footer" *ngIf="!show">{{"footer.popin-footer.label-short"| translate}}</div>
    <div class="find-out" *ngIf="!show" (click)="!show = !show">{{"footer.popin-footer.find-out-more"| translate}}</div>
    <div class="popin_footer" *ngIf="show">{{"footer.popin-footer.label-long" | translate}}</div>
</div>